import { TextField } from "@mui/material"
import React, { useEffect, useRef, useState } from "react"

export const InputCell = ({ name, initialValue, onChangeAsync, ...rest }) => {
  const [value, setValue] = useState(initialValue)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    let mounted = true
    if (mounted) {
      setValue(initialValue)
      setError(false)
    }

    return () => {
      mounted = false
    }
  }, [initialValue])

  const handleUpdate = () => {
    if (initialValue !== value) {
      setLoading(true)
      setError(false)
      onChangeAsync(value)
        .catch(() => {
          setError(true)
          setValue(initialValue)
        })
        .finally(() => setLoading(false))
    }
  }

  return (
    <TextField
      name={name}
      fullWidth
      inputRef={ref}
      disabled={loading}
      value={value}
      error={error}
      onChange={(e) => setValue(e.target.value)}
      onKeyUp={(e) => {
        if (e.key === "Enter" && ref.current?.blur) {
          ref.current.blur()
        }
      }}
      onBlur={handleUpdate}
      {...rest}
    />
  )
}
